// @flow
// SORT modals here - you can prioritize modals for prevent overflowing modals

export type ReservationModals =
  | "apiErrors"
  | "payment"
  | "information"
  | "formErrors"
  | "additionalServices"

export const RESERVATION_MODALS_TYPES: { [string]: ReservationModals } = {
  API_ERRORS: "apiErrors",
  PAYMENT: "payment",
  INFORMATION: "information",
  FORM_ERRORS: "formErrors",
  ADDITIONAL_SERVICES: "additionalServices",
}

export type PaymentModals = "failures" | "threeDs"

export const PAYMENT_MODALS_TYPES: { [string]: PaymentModals } = {
  FAILURES: "failures",
  THREE_DS: "threeDs",
}

export type PaymentFailuresModals = "user" | "system" | "general"

export const PAYMENT_FAILURES_MODALS_TYPES: { [string]: PaymentFailuresModals } = {
  USER: "user",
  SYSTEM: "system",
  GENERAL: "general",
}

export type InformationModals =
  | "abandonment"
  | "insurance"
  | "conditions"
  | "summary"
  | "scheduleChange"
  | "newsletter"
  | "error"
  | "gracePeriod"
  | "travelTip"
  | "cancelledPayment"
  | "hotelAdvertisement"
  | "exitBanner"

export const INFORMATION_MODALS_TYPES: { [string]: InformationModals } = {
  ERROR: "error",
  ABANDONMENT: "abandonment",
  INSURANCE: "insurance",
  CONDITIONS: "conditions",
  SUMMARY: "summary",
  SCHEDULE_CHANGE: "scheduleChange",
  NEWSLETTER: "newsletter",
  GRACE_PERIOD: "gracePeriod",
  PAYMENT_CANCELLED: "cancelledPayment",
  TRAVEL_TIP: "travelTip",
  HOTEL_ADVERTISEMENT: "hotelAdvertisement",
  EXIT_BANNER: "exitBanner",
}

export type InformationErrorModals = "invalid" | "priceChange" | "failure"

export const INFORMATION_ERRORS_MODALS_TYPES: { [string]: InformationErrorModals } = {
  INVALID: "invalid",
  PRICE_CHANGE: "priceChange",
  FAILURE: "failure",
}

export type FormErrorsModals = "visaException" | "duplicatePassenger" | "notEnoughAdults"

export const FORM_ERRORS_MODALS_TYPES: { [string]: FormErrorsModals } = {
  VISA_EXCEPTION: "visaException",
  DUPLICATE_PASSENGER: "duplicatePassenger",
  NOT_ENOUGH_ADULTS: "notEnoughAdults",
}

export type ApiErrorsModals = "duplicateBooking"

export const API_ERRORS_MODALS_TYPES: { [string]: ApiErrorsModals } = {
  DUPLICATE_BOOKING: "duplicateBooking",
}

export type AdditionalServicesModals = "multistepInsurance" | "priorityBoarding"

export const ADDITIONAL_SERVICES_MODALS_TYPES: { [string]: AdditionalServicesModals } = {
  MULTISTEP_INSURANCE: "multistepInsurance",
  PRIORITY_BOARDING: "priorityBoarding",
}

export type ReservationModalsNames =
  | InformationModals
  | InformationErrorModals
  | FormErrorsModals
  | ApiErrorsModals
  | AdditionalServicesModals
  | PaymentFailuresModals

// SORT END - just export all modals //

export const RESERVATION_MODALS = {
  ABANDONMENT: [RESERVATION_MODALS_TYPES.INFORMATION, INFORMATION_MODALS_TYPES.ABANDONMENT],
  CONDITIONS: [RESERVATION_MODALS_TYPES.INFORMATION, INFORMATION_MODALS_TYPES.CONDITIONS],
  NEWSLETTER: [RESERVATION_MODALS_TYPES.INFORMATION, INFORMATION_MODALS_TYPES.NEWSLETTER],
  SUMMARY: [RESERVATION_MODALS_TYPES.INFORMATION, INFORMATION_MODALS_TYPES.SUMMARY],
  SCHEDULE_CHANGE: [RESERVATION_MODALS_TYPES.INFORMATION, INFORMATION_MODALS_TYPES.SCHEDULE_CHANGE],
  ERROR: {
    INVALID: [
      RESERVATION_MODALS_TYPES.INFORMATION,
      INFORMATION_MODALS_TYPES.ERROR,
      INFORMATION_ERRORS_MODALS_TYPES.INVALID,
    ],
    PRICE_CHANGE: [
      RESERVATION_MODALS_TYPES.INFORMATION,
      INFORMATION_MODALS_TYPES.ERROR,
      INFORMATION_ERRORS_MODALS_TYPES.PRICE_CHANGE,
    ],
    FAILURE: [
      RESERVATION_MODALS_TYPES.INFORMATION,
      INFORMATION_MODALS_TYPES.ERROR,
      INFORMATION_ERRORS_MODALS_TYPES.FAILURE,
    ],
  },
  PAYMENT_CANCELLED: [
    RESERVATION_MODALS_TYPES.INFORMATION,
    INFORMATION_MODALS_TYPES.PAYMENT_CANCELLED,
  ],
  GRACE_PERIOD: [RESERVATION_MODALS_TYPES.INFORMATION, INFORMATION_MODALS_TYPES.GRACE_PERIOD],
  VISA_EXCEPTION: [RESERVATION_MODALS_TYPES.FORM_ERRORS, FORM_ERRORS_MODALS_TYPES.VISA_EXCEPTION],
  DUPLICATE_PASSENGER: [
    RESERVATION_MODALS_TYPES.FORM_ERRORS,
    FORM_ERRORS_MODALS_TYPES.DUPLICATE_PASSENGER,
  ],
  NOT_ENOUGH_ADULTS: [
    RESERVATION_MODALS_TYPES.FORM_ERRORS,
    FORM_ERRORS_MODALS_TYPES.NOT_ENOUGH_ADULTS,
  ],
  DUPLICATE_BOOKING: [
    RESERVATION_MODALS_TYPES.API_ERRORS,
    API_ERRORS_MODALS_TYPES.DUPLICATE_BOOKING,
  ],
  INSURANCE: [RESERVATION_MODALS_TYPES.INFORMATION, INFORMATION_MODALS_TYPES.INSURANCE],
  TRAVEL_TIP: [RESERVATION_MODALS_TYPES.INFORMATION, INFORMATION_MODALS_TYPES.TRAVEL_TIP],
  HOTEL_ADVERTISEMENT: [
    RESERVATION_MODALS_TYPES.INFORMATION,
    INFORMATION_MODALS_TYPES.HOTEL_ADVERTISEMENT,
  ],
  EXIT_BANNER: [RESERVATION_MODALS_TYPES.INFORMATION, INFORMATION_MODALS_TYPES.EXIT_BANNER],
  MULTISTEP_INSURANCE: [
    RESERVATION_MODALS_TYPES.ADDITIONAL_SERVICES,
    ADDITIONAL_SERVICES_MODALS_TYPES.MULTISTEP_INSURANCE,
  ],
  PRIORITY_BOARDING: [
    RESERVATION_MODALS_TYPES.ADDITIONAL_SERVICES,
    ADDITIONAL_SERVICES_MODALS_TYPES.PRIORITY_BOARDING,
  ],
  PAYMENT: {
    FAILURES: {
      USER: [
        RESERVATION_MODALS_TYPES.PAYMENT,
        PAYMENT_MODALS_TYPES.FAILURES,
        PAYMENT_FAILURES_MODALS_TYPES.USER,
      ],
      SYSTEM: [
        RESERVATION_MODALS_TYPES.PAYMENT,
        PAYMENT_MODALS_TYPES.FAILURES,
        PAYMENT_FAILURES_MODALS_TYPES.SYSTEM,
      ],
      GENERAL: [
        RESERVATION_MODALS_TYPES.PAYMENT,
        PAYMENT_MODALS_TYPES.FAILURES,
        PAYMENT_FAILURES_MODALS_TYPES.GENERAL,
      ],
    },
    THREE_DS: [RESERVATION_MODALS_TYPES.PAYMENT, PAYMENT_MODALS_TYPES.THREE_DS],
    LOADER: [RESERVATION_MODALS_TYPES.PAYMENT, PAYMENT_MODALS_TYPES.LOADER],
  },
}
